<template>
  <img :src="imageSrc" :alt="alt" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useColorMode } from '@vueuse/core';

type ImagePropsType = {
  src: string;
  alt: string;
};

const props = defineProps<ImagePropsType>();

const colorMode = useColorMode();

const imagePath = computed(() => {
  if (colorMode.value === 'dark') {
    return `${props.src}_dark.svg`;
  }

  return `${props.src}_light.svg`;
});
const imageSrc = computed(() => {
  try {
    return new URL(`../assets/images/${imagePath.value}`, import.meta.url).href;
  } catch (err) {
    return '';
  }
});
</script>
